import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StripeSliceState } from "../../types/store";
import { ProductWithPrice } from "../../types/stripe";
import { Stripe } from "@stripe/stripe-js";

export const STRIPE_SLICE = 'stripe' as const;

const initialState: StripeSliceState = {
  products: [],
  loadingProducts: false,
  loadProductsError: null,
  stripeInstance: null,
}

export const stripeSlice = createSlice({
  name: STRIPE_SLICE,
  initialState: initialState,
  reducers: {
    loadStripeInstance: (
      state: StripeSliceState,
      { payload: stripe }: PayloadAction<Stripe | null>
    ) => {
      state.stripeInstance = stripe;
    },
    loadStripeProducts: (
      state: StripeSliceState,
      { payload: _ }: PayloadAction<undefined>
    ) => {
      state.loadingProducts = true;
    },
    loadStripeProductsSuccess: (
      state: StripeSliceState,
      { payload: products }: PayloadAction<ProductWithPrice[]>
    ) => {
      state.products = products;
      state.loadingProducts = false;
      state.loadProductsError = null;
    },
    loadStripeProductsError: (
      state: StripeSliceState,
      { payload: error }: PayloadAction<any>
    ) => {
      state.products = [];
      state.loadingProducts = false;
      state.loadProductsError = error;
    },
  }
});

export const {
  loadStripeProducts,
  loadStripeProductsError,
  loadStripeProductsSuccess,
  loadStripeInstance,
} = stripeSlice.actions;

export default stripeSlice.reducer;